import Marquee from "react-fast-marquee";

const Dot = () => (
    <span
        aria-hidden
        className="inline-block h-1.5 w-1.5 rounded-full bg-[color:var(--charcoal)] mx-8 md:mx-14 translate-y-[-8px]"
    />
);

export default function EditorialMarquee() {
    const phrases = [
        "Equity",
        "Nation",
        "Canada",
        "Equity",
        "Nation",
        "Canada",
    ];

    return (
        <div
            data-testid="editorial-marquee"
            className="relative border-y border-[color:var(--charcoal)] bg-[color:var(--sky-base)]/60 backdrop-blur-sm py-[10px] md:py-[13px] overflow-hidden"
        >
            <Marquee
                speed={38}
                gradient={false}
                pauseOnHover={false}
                autoFill
            >
                <div className="flex items-center">
                    {phrases.map((p, i) => (
                        <span key={i} className="flex items-center">
                            <span className="font-display italic text-[6.4vw] md:text-[4.48vw] leading-none tracking-[-0.02em] text-[color:var(--charcoal)]">
                                {p}
                            </span>
                            <Dot />
                        </span>
                    ))}
                </div>
            </Marquee>
        </div>
    );
}
